import { Component, input, signal } from '@angular/core';
import { NgIf, NgClass, NgSwitch, NgSwitchCase } from '@angular/common';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [NgIf, NgClass, NgSwitchCase, NgSwitch],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  title   = input<string>('Loading');
  message = input<string>('Please wait a moment…');
  variant = input<'spinner'|'dots'>('spinner');
  size    = input<'sm'|'md'|'lg'>('md');
  /** When false, the component renders just the spinner/card; you supply overlay wrapper */
  backdrop = input<boolean>(true);

  sizeClass = signal(() => {
    const s = this.size();
    return s === 'sm' ? 'size-sm' : s === 'lg' ? 'size-lg' : '';
  });
}
